import { render } from "./EletricidadePage.vue?vue&type=template&id=08eb35e1&scoped=true"
import script from "./EletricidadePage.vue?vue&type=script&lang=js"
export * from "./EletricidadePage.vue?vue&type=script&lang=js"

import "./EletricidadePage.vue?vue&type=style&index=0&id=08eb35e1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08eb35e1"]])

export default __exports__